{
  "nav": {
    "dashboard": "Dashboard",
    "fleet": "Fleet",
    "alerts": "Alerts",
    "history": "History",
    "health": "Health",
    "geofences": "Geofences",
    "reports": "Reports",
    "settings": "Settings",
    "admin": "Admin",
    "more": "More"
  },
  "dashboard": {
    "underProtection": "Under protection",
    "fleetOnline": "Fleet online",
    "allConnected": "All connected",
    "offline": "offline",
    "costPerKm": "Cost / km · today",
    "noTripsToday": "No trips yet today",
    "theftEvents": "Theft events",
    "theftPrevented": "Theft prevented",
    "activeTheft": "Active theft",
    "noActiveTheft": "None active",
    "caught": "caught",
    "requiresAttention": "Requires attention",
    "noTheftDetected": "No theft detected",
    "fleetMap": "Fleet map",
    "liveMap": "Live map",
    "online": "Online",
    "alert": "Alert",
    "value": "Value",
    "lastEvent": "Last event",
    "lastSeen": "Last seen",
    "viewDetails": "View details",
    "reviewAlerts": "Review",
    "refuel": "Refuel",
    "noTrucksInFleet": "No trucks in your fleet",
    "addFirstTruck": "Add your first truck",
    "goToFleet": "Go to the Fleet tab to add your first truck and start monitoring fuel.",
    "refuelSchedule": "Refuel schedule",
    "needAttention": "truck needs attention",
    "needAttentionPlural": "trucks need attention",
    "critical": "critical",
    "high": "high",
    "medium": "medium",
    "emptyIn": "Empty in",
    "updatedAgo": "Updated",
    "secondsAgo": "s ago",
    "minutesAgo": "m ago",
    "live": "Live",
    "liveHint": "Real-time updates connected",
    "signOut": "Sign out"
  },
  "fleet": {
    "trucks": "trucks",
    "truck": "truck",
    "fuel": "Fuel",
    "status": "Status",
    "lastSeen": "Last seen",
    "online": "Online",
    "offline": "Offline",
    "never": "Never",
    "search": "Search trucks…",
    "addTruck": "Add truck",
    "noTrucks": "No trucks yet"
  },
  "truckDetail": {
    "fuelLevel": "Fuel level",
    "history": "History",
    "consumption": "Consumption",
    "location": "Location",
    "close": "Close",
    "liters": "L",
    "full": "full",
    "empty": "empty"
  },
  "alerts": {
    "title": "Alerts",
    "subtitle": "Acknowledge and resolve fuel-security events across your fleet",
    "theft": "Theft detected",
    "correlated": "Coordinated theft",
    "tamper": "Tamper detected",
    "geofence": "Geofence breach",
    "afterHours": "After-hours movement",
    "anomaly": "Anomaly",
    "acknowledge": "Acknowledge",
    "acknowledged": "Acknowledged",
    "resolve": "Resolve",
    "markResolved": "Mark resolved",
    "reopen": "Reopen alert",
    "evidence": "Evidence",
    "downloadEvidence": "Download evidence (PDF)",
    "statusOpen": "Open",
    "statusAcknowledged": "Acknowledged",
    "statusResolved": "Resolved",
    "tab_open": "Open",
    "tab_acknowledged": "Acknowledged",
    "tab_resolved": "Resolved",
    "tab_all": "All",
    "loadError": "Couldn't load alerts.",
    "emptyOpen": "No open alerts",
    "emptyGeneric": "No alerts here",
    "emptyHint": "All clear — no fuel-security events need your attention.",
    "unknownTruck": "Unknown truck",
    "litresLost": "Litres lost",
    "valueLost": "Value lost",
    "tank": "Tank",
    "tankLeft": "Left",
    "tankRight": "Right",
    "speed": "Speed",
    "location": "Location",
    "acknowledgedBy": "Acknowledged by",
    "resolvedBy": "Resolved by",
    "resolutionPlaceholder": "Add a resolution note (optional)…",
    "ackDone": "Alert acknowledged",
    "resolveDone": "Alert resolved",
    "reopenDone": "Alert reopened",
    "detection": "Detection",
    "verdict_high": "High confidence",
    "verdict_medium": "Medium confidence",
    "verdict_low": "Low confidence",
    "markFalsePositive": "Mark as false positive",
    "falsePositiveDone": "Marked as false positive",
    "falsePositiveTag": "False positive",
    "confidence": "Confidence"
  },
  "settings": {
    "profile": "My Profile",
    "organization": "Organization",
    "alertsNotifications": "Alerts & notifications",
    "webhooks": "Webhooks",
    "team": "Team",
    "devices": "Devices",
    "displayName": "Display name",
    "emailAddress": "Email address",
    "language": "Language",
    "changePassword": "Change password",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "saveChanges": "Save changes",
    "profileUpdated": "Profile updated"
  },
  "auth": {
    "signIn": "Sign in",
    "signingIn": "Signing in…",
    "email": "Email",
    "password": "Password",
    "forgotPassword": "Forgot password?",
    "welcomeBack": "Protect your fleet"
  },
  "common": {
    "loading": "Loading…",
    "error": "Something went wrong",
    "retry": "Try again",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "confirm": "Confirm",
    "close": "Close",
    "search": "Search",
    "noData": "No data",
    "ago": "ago",
    "liters": "L",
    "km": "km"
  },
  "push": {
    "title": "Get alerted for theft in real time",
    "body": "Turn on notifications and Tankguard will buzz your phone the moment a theft, tamper or low-fuel event fires — even when the app is closed.",
    "allow": "Enable alerts",
    "later": "Not now",
    "enabled": "Real-time alerts enabled",
    "blocked": "Notifications are blocked in your browser settings. Allow them for this site to receive alerts.",
    "failed": "Couldn't enable notifications. Please try again."
  },
  "install": {
    "title": "Add Tankguard to your home screen",
    "body": "Install the app for full-screen, one-tap access to your fleet.",
    "action": "Install",
    "dismiss": "Not now"
  }
}
